import { Typography } from "@mui/material";

export const Contact = () => {
  return <Typography>Contact Us</Typography>;
};
